var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},[_c('Doc'),_c('v-divider'),_c('Hours',{attrs:{"biz":_vm.biz},on:{"updated":_vm.updated}}),_c('v-divider'),_c('Throttle')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }